const getValue = (data: any, keys: string[], fallback: any = '') => {
  for (const key of keys) {
    if (data?.[key] !== undefined && data?.[key] !== null) return data[key]
  }

  return fallback
}

// All print entry points use backend values first, with form data as a fallback.
export const getNajavaUtovaraPdfData = (najava: any, fallback: any = {}) => {
  const fields: Record<string, string[]> = {
    idNajaveUtovara: ['Id', 'id', 'idNajaveUtovara'],
    kupac: ['Kupac', 'kupac'],
    kontaktOsoba: ['KontaktOsoba', 'kontaktOsoba'],
    vozacIme: ['VozacIme', 'vozacIme'],
    vozacFirma: ['VozacFirma', 'vozacFirma'],
    vozacTel: ['VozacTel', 'vozacTel'],
    regKamion: ['RegKamion', 'regKamion'],
    regPrikolica: ['RegPrikolica', 'regPrikolica'],
    datumUtovara: ['DatumUtovara', 'datumUtovara'],
    vrijemeUtovara: ['VrijemeUtovara', 'vrijemeUtovara'],
    granicniPrelaz: ['GranicniPrelaz', 'granicniPrelaz'],
    brojPasosa: ['BrojPasosa', 'brojPasosa'],
    emailDokumentacija: ['EmailDokumentacija', 'emailDokumentacija'],
    napomene: ['Napomene', 'napomene', 'Napomena', 'napomena'],
    ugovorenaCijenaBam: ['UgovorenaCijenaTransportaKM', 'ugovorenaCijenaBam'],
    ugovorenaCijenaEur: ['UgovorenaCijenaTransportaEUR', 'ugovorenaCijenaEur'],
    dodatniUtovarRobe: ['DodatniUtovar', 'dodatniUtovarRobe'],
    brojNalogaDodatniUtovarRobe: ['DodatniUtovarNalozi', 'brojNalogaDodatniUtovarRobe'],
    transport: ['Transport', 'transport'],
    fakturisatiTransport: ['FakturisatiTransport', 'fakturisatiTransport'],
    fakturisatiTransportNalog: ['FakturisatiTransportNalog', 'fakturisatiTransportNalog'],
    carisnkiPostupak: ['CarisnkiPostupak', 'carisnkiPostupak'],
  }
  const data: any = {}

  Object.entries(fields).forEach(([field, keys]) => {
    data[field] = getValue(najava, keys, getValue(fallback, keys))
  })

  data.roba = getValue(najava, ['stavke', 'NajavaUtovaraStavke', 'roba'], fallback.roba ?? [])
  const firstStavka = data.roba[0]
  const istovarFields: Record<string, string[]> = {
    istovar1: ['Istovar1', 'istovar1'],
    istovar1Kontakt: ['KontaktIstovar1', 'kontaktIstovar1', 'Istovar1Kontakt', 'istovar1Kontakt'],
    istovar2: ['Istovar2', 'istovar2'],
    istovar2Kontakt: ['KontaktIstovar2', 'kontaktIstovar2', 'Istovar2Kontakt', 'istovar2Kontakt'],
  }

  Object.entries(istovarFields).forEach(([field, keys]) => {
    data[field] = getValue(firstStavka, keys, getValue(najava, keys, getValue(fallback, keys)))
  })

  return data
}
